import {Component, Inject, OnInit} from '@angular/core';
import {BatchExportReportDetailsResponseEntity} from '../../shared/models';
import {NgRedux, select} from '@angular-redux/store';
import {Observable} from 'rxjs';
import {BatchExportStatus} from '../../shared/enums';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {IAppState} from '../../store/IAppState';
import {BatchExportServiceToken, HttpBatchExportService} from '../services/batch-export.service';
import {isFeatureEnabled} from '../../shared/helpers';
import {FeatureToggleEntries} from '../../shared/feature-toggle-settings-enum';
import {
  ExportedReportsDialogColumn,
  getColumnsForExportedOneTimeReportsDialog,
  getScheduleColumnsForExportedReportsDialog
} from '../batch-export-helper';

@Component({
  selector: 'app-reports-dialog',
  templateUrl: './exported-reports-dialog.component.html',
  styleUrls: ['./exported-reports-dialog.component.scss']
})
export class ExportedReportsDialogComponent implements OnInit {

  BatchExportStatus = BatchExportStatus;

  @select(['data', 'batchExportReportDetails'])
  private readonly batchExportReportDetails$: Observable<BatchExportReportDetailsResponseEntity[]>;
  columns: ExportedReportsDialogColumn[] = [];
  columnsForOneTimeTab: ExportedReportsDialogColumn[] = [];
  stringColumnsForRowDefForOneTimeTab: string[] = [];
  columnsForScheduledTab: ExportedReportsDialogColumn[] = [];
  stringColumnsForRowDefForScheduledTab: string[] = [];
  dataSource: BatchExportReportDetailsResponseEntity[] = [];
  showPostDownloadPopup = false;
  redesignEnabled: boolean;
  cancelDeleteScheduledReportsEnabled: boolean;

  constructor(private readonly ngRedux: NgRedux<IAppState>,
              public dialogRef: MatDialogRef<ExportedReportsDialogComponent>,
              @Inject(BatchExportServiceToken) private batchExportService: HttpBatchExportService,
              public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.batchExportReportDetails$.subscribe((batchExportReportDetails: BatchExportReportDetailsResponseEntity[]) => {
      this.dataSource = batchExportReportDetails;
    });
    const stateData = this.ngRedux.getState().data;
    this.redesignEnabled =
      isFeatureEnabled(FeatureToggleEntries.REDESIGN_MULTIPROVIDER_EXPORT, stateData.featureToggleSettings, stateData.userProfile);
    this.cancelDeleteScheduledReportsEnabled =
      isFeatureEnabled(FeatureToggleEntries.CANCEL_DELETE_SCHEDULED_EXPORTS, stateData.featureToggleSettings, stateData.userProfile);
    this.setUpColumnArraysForTable();
  }

  private setUpColumnArraysForTable() {
    this.columnsForOneTimeTab = getColumnsForExportedOneTimeReportsDialog();
    this.stringColumnsForRowDefForOneTimeTab = this.columnsForOneTimeTab.map(c => c.columnDef);

    this.columnsForScheduledTab = getScheduleColumnsForExportedReportsDialog(this.cancelDeleteScheduledReportsEnabled);
    this.stringColumnsForRowDefForScheduledTab = this.columnsForScheduledTab.map(c => c.columnDef);
  }

  close() {
    this.dialogRef.close();
  }

  closePostDownloadPopup() {
    this.showPostDownloadPopup = false;
  }

  updateShowPostDownloadPopup(show: boolean) {
    this.showPostDownloadPopup = show;
  }
}
